import {Action} from "redux-actions";
import Meta from "../_data/models/Meta";
import {
    receiveComments,
    requestComments,
    clearComments,  
} from "./actions";
import Comment from "../_data/models/Comment";
import {combineReducers} from "redux";

export const commentsReducer = combineReducers({
    items: items,
    meta,
    loading: loading
});

export default commentsReducer;

function items(state: Comment[] = [], action: Action<commentAction>) {
    switch (action.type) {
        case clearComments.toString():
            return [];
        case receiveComments.toString():
            return [...state, ...action.payload.comments];
    }
    return state;
}

function meta(state: Meta = null, action: Action<commentAction>) {
    switch (action.type) {
        case clearComments.toString():
            return null;
        case receiveComments.toString():
            return action.payload.meta;
    }
    return state;
}

function loading(state: boolean = false, action: Action<commentAction>) {
    switch (action.type) {
        case requestComments.toString():
            return true;
        case receiveComments.toString():
            return false;
    }
    return state;
}

interface commentAction {
    comments: Comment[];
    meta: Meta;
}


// WEBPACK FOOTER //
// ./app/client/comment/reducers.ts